import React, { Component } from "react";
import UI from "../../shared/Components/UI/js";
import ForgetPasswordStep2 from "../../ComponentsFC/forget_password_step_2/ForgetPasswordStep2";
const context = "signup";

export default class OnboardForgetPasswordStep2 extends Component {
  constructor(props) {
    super(props);
    UI.initiateView(this, {
      //Initial State Here
      remember_me: false,
      context: context,
    });
  }

  onCreate = async () => {};

  render() {
    return (
      <>
        <ForgetPasswordStep2 _this={this} />
      </>
    );
  }
}
